import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const copper = defineConnector({
  identifier: "copper",
  name: "Copper",
  tagLine: "CRM for Google Workspace",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.copper\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "X-PW-AccessToken", value: app.secret.apiKey },
      { name: "X-PW-UserEmail", value: app.config.email },
      {
        name: "X-PW-Application",
        value: "developer_api",
      },
    ]),
  steps: [
    {
      title: "Get your Copper API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Copper, go to **Settings > Integrations > API Keys** and generate a new API key. You'll also need your email address associated with your Copper account.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Email address",
          required: true,
          target: { kind: "configuration", field: "email" },
          helperText: "The email address associated with your Copper account.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.copper.com/developer_api/v1/account",
  },
});
